import { apiWrapper } from './helpers';

export function getAvailableTiers() {
    return apiWrapper(
        '/vendor/v1/account/tiers',
        'GET',
        'GET AVAILABLE TIERS',
    );
}

export function requestTierUpgrade(newTier = 0) {
    return apiWrapper(
        '/vendor/v1/account/subscriptions/upgrade',
        'POST',
        'REQUEST TIER UPGRADE',
        JSON.stringify({ tier: newTier }),
        () => {},
        { 'Content-Type': 'application/json' }
    );
}

export function getTierProration(newTier = 0) {
    /*
       {
            "credit_for_unused_times": {
                "amount": -1436,
                "description": "Unused time on Truckster vendor subscription - Tier 1 after 02 Sep 2023",
                "period_start_at": "2023-09-02 06:39:56",
                "period_end_at": "2023-10-01 00:00:00"
            },
            "cost_for_time_spent": {
                "amount": 3830,
                "description": "Remaining time on Truckster vendor subscription - Tier 3 after 02 Sep 2023",
                "period_start_at": "2023-09-02 06:39:56",
                "period_end_at": "2023-10-01 00:00:00"
            },
            "cost_for_next_period": {
                "amount": 4000,
                "description": "1 × Truckster vendor subscription - Tier 3 (at $40.00 / month)",
                "period_start_at": "2023-10-01 00:00:00",
                "period_end_at": "2023-11-01 00:00:00"
            },
            "new_total": 6394
        }
     */
    return apiWrapper(
        '/vendor/v1/account/subscriptions/preview-proration',
        'POST',
        'GET TIER PRORATION DATA',
        JSON.stringify({ tier: newTier }),
    );
}

export function sendCancellationRequest() {
    return apiWrapper(
        '/vendor/v1/account/subscriptions/consider-cancellation',
        'POST',
        'SEND SUBSCRIPTION CANCELLATION REQUEST TO SLACK'
    );
}

// region Saved Payment Methods
export function getNewPaymentMethodIntentData(afterTrialTier = null, forCatering = false) {
    return apiWrapper(
        '/vendor/v1/account/setup-intent',
        'POST',
        'GET INTENT FOR NEW PAYMENT METHOD',
        forCatering ? JSON.stringify({ type: 'for_cof_only' }) : (afterTrialTier ? JSON.stringify({ after_trial_tier: afterTrialTier }) : null),
        () => {},
        { 'Content-Type': 'application/json' }
    );
}

export function getPaymentMethods() {
    return apiWrapper(
        '/vendor/v1/account/pm-cards',
        'GET',
        'GET SAVED PAYMENT METHODS',
    );
}

export function deletePaymentMethod(cardID = null) {
    return apiWrapper(
        `/vendor/v1/account/pm-cards/${cardID}`,
        'DELETE',
        'DELETE SAVED PAYMENT METHOD',
    );
}

export function setDefaultPaymentMethod(cardID = null) {
    return apiWrapper(
        `/vendor/v1/account/pm-cards/${cardID}/default`,
        'POST',
        'SET DEFAULT PAYMENT METHOD',
    );
}

// endregion
